import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column"
import ControlGroup from "@amzn/meridian/control-group"
import RadioButton from "@amzn/meridian/radio-button"
import {ReceiveFilterContext} from "./context/ReceiveFilterContext";
import {
    getCycleDataFromParent, getFeaturesFromParent,
    getNodeCapabilityFromParent
} from "../handler/ParentDataHandler";
import {injectIntl} from "react-intl";
import {chainWalk, parseCapabilitiesResponse} from "../util/Util";
import {ConfigContext} from "../global/context/ConfigContext";
import {ACTION_TYPE, CAPABILITY, FEATURES} from "../util/Constants";
import {MobileDisplay} from "../common/MobileDisplay";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import FilterExpander from "../common/FilterExpander";
import ReceiveFilterTags from "./ReceiveFilterTags";

const ReceiveFilter = ({ intl }) => {
    const { filter,  dispatch } = useContext(ReceiveFilterContext)
    const {configDispatch, configViewModel} = useContext(ConfigContext);
    const {isMobile} = useDeviceLayout();

    useEffect(() => {
        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = parseCapabilitiesResponse(capabilityResponse)
            configDispatch({type: 'GET_CAPABILITIES', capability});
            getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatus =>{
                configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
                if(isCPTFilterEnabled){
                    dispatch({ type: 'LOAD_CPT_LIST', data:{dispatcher: dispatch}});
                }
                else{
                    getCycleDataFromParent().then(cycleData => {
                        dispatch({ type: 'INITIALIZE_CYCLES', cycleData: cycleData});
                    })
                }
            })
        })
    }, []);

    const isCPTFilterEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false);

    if (CAPABILITY.AR_NEXT_GEN === configViewModel.capability) {
        return null
    }

    const renderCPTControls = () => {
        return (
            <ControlGroup
                label={intl.formatMessage({id: 'CPT.'+ filter.CPTLabel})}
                name="CPT"
                onChange={(data) => dispatch({ type: 'SELECT_CPT', CPT: data })}
                value={filter.selectedCPT[0]}>
                {
                    filter.allCPT.map((CPT, index) => {
                    return <RadioButton key={index} value={CPT.label}>{CPT.label}</RadioButton>
                })}
            </ControlGroup>
        );
    }

    const renderCPTFilterSection = () => {
        return (
            <React.Fragment>
                {renderCPTControls()}
                {filter.selectedCPT.length > 0 && (
                    <Row width="100%" spacingInset="small none none none">
                        <ReceiveFilterTags items={filter.selectedCPT} />
                    </Row>
                )}
            </React.Fragment>
        );
    }

    function displayCPTData() {
        return (
            <Column spacing="small" spacingInset="none none medium none">
                {isMobile ?
                    <Column alignmentHorizontal={"stretch"} alignmentVertical={"center"} spacingInset={"small medium"} backgroundColor="secondary">
                        {renderCPTFilterSection()}
                    </Column> :
                    <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                        {renderCPTControls()}
                    </Row>
                }
                <MobileDisplay visibility={false}>
                    <Row width="100%" spacingInset="none">
                        <ReceiveFilterTags items={filter.selectedCPT} />
                    </Row>
                </MobileDisplay>
            </Column>
        )
    }

    const renderCycleControls = () => {
        return (
            <ControlGroup
                label={intl.formatMessage({id: 'receive.filter.cycle'})}
                name="cycle"
                onChange={(data) => dispatch({ type: 'SELECT_CYCLE', cycle: data})}
                value={filter.selectedCycles[0]}>
                {filter.allCycles.map((cycle, index) => {
                    return <RadioButton key={index} value={cycle.cycleName}>{cycle.displayableName}</RadioButton>
                })}
            </ControlGroup>
        );
    }

    const renderCycleFilterSection = () => {
        return (
            <React.Fragment>
                {renderCycleControls()}
                {filter.selectedCycles.length > 0 && (
                    <Row width="100%" spacingInset="small none none none">
                        <ReceiveFilterTags items={filter.selectedCycles} />
                    </Row>
                )}
            </React.Fragment>
        );
    }

    function displayCycleData(){
        return (
            <Column spacing="small" spacingInset="none none medium none">
                {isMobile ?
                    <Column alignmentHorizontal={"stretch"} alignmentVertical={"center"} spacingInset={"small medium"} backgroundColor="secondary">
                        {renderCycleFilterSection()}
                    </Column> :
                    <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
                        {renderCycleControls()}
                    </Row>
                }
                <MobileDisplay visibility={false}>
                    <Row width="100%" spacingInset="none">
                        <ReceiveFilterTags items={filter.selectedCycles} />
                    </Row>
                </MobileDisplay>
            </Column>
        )
    }

    function renderFilterOptions() {
        if(isCPTFilterEnabled)
            return displayCPTData();
        else
            return displayCycleData();
    }

    return(
        <React.Fragment>
            {isMobile ?
            <FilterExpander>
                {renderFilterOptions()}
            </FilterExpander> : renderFilterOptions()}
        </React.Fragment>
    )


}

export default injectIntl(ReceiveFilter);


// WEBPACK FOOTER //
// ./src/components/receive/ReceiveFilter.js